import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useFormContext } from "react-hook-form";
import TextField from "../../Form/TextField";
import LmsIntegrationDomainService from "../../../Domain/LmsIntegration/LmsIntegration.service";
import CustomCard from "../../UI/CustomCard/CustomCard";
import SearchField from "../../Form/SearchField";
import { LmsIntegrationSearch } from "./LmsIntegrationSearch";
import LmsConfigurationDomainService from "../../../Domain/LmsConfiguration/LmsConfiguration.service";
import NumberField from "../../Form/NumberField";
import CheckboxField from "../../Form/CheckboxField";
export const sortFormDefaultConfigurationValues = (lmsConfigurations, selectedLmsIntegration) => {
    var _a;
    const lmsIntegrationConfigurations = lmsConfigurations.filter((lmsConfiguration) => lmsConfiguration.lmsIntegration.id === selectedLmsIntegration.id &&
        !lmsConfiguration.advanced);
    const advancedGenericLmsIntegrationConfiguration = lmsConfigurations.filter((lmsConfiguration) => lmsConfiguration.lmsIntegration.id ===
        LmsIntegrationDomainService.general.id);
    const advancedLmsIntegrationConfigurations = lmsConfigurations.filter((lmsConfiguration) => lmsConfiguration.lmsIntegration.id === selectedLmsIntegration.id &&
        lmsConfiguration.advanced);
    return {
        lmsIntegrationConfiguration: Object.assign({}, lmsIntegrationConfigurations.reduce((acc, configuration) => (Object.assign(Object.assign({}, acc), { [configuration.key]: {
                stringValue: configuration.stringValue,
                longValue: configuration.longValue,
                booleanValue: configuration.booleanValue,
            } })), {})),
        advancedLmsIntegrationConfiguration: Object.assign({}, advancedLmsIntegrationConfigurations.reduce((acc, configuration) => (Object.assign(Object.assign({}, acc), { [configuration.key]: {
                stringValue: configuration.stringValue,
                longValue: configuration.longValue,
                booleanValue: configuration.booleanValue,
            } })), {})),
        advancedGenericLmsIntegrationConfiguration: Object.assign({}, advancedGenericLmsIntegrationConfiguration.reduce((acc, configuration) => (Object.assign(Object.assign({}, acc), { [configuration.key]: {
                stringValue: configuration.stringValue,
                longValue: configuration.longValue,
                booleanValue: configuration.booleanValue,
            } })), {})),
        lmsIntegration: (_a = lmsIntegrationConfigurations.find((a) => a.lmsIntegration.id === selectedLmsIntegration.id)) === null || _a === void 0 ? void 0 : _a.lmsIntegration,
    };
};
export const getLmsIntegrationConfigurationSaveRequest = (formState, selectedLmsIntegration) => {
    const lmsIntegration = Object.entries(Object.assign(Object.assign({}, formState.lmsIntegrationConfiguration), formState.advancedLmsIntegrationConfiguration)).map(([key, value]) => ({
        key,
        stringValue: value.stringValue,
        longValue: value.longValue,
        booleanValue: value.booleanValue,
        lmsIntegrationId: selectedLmsIntegration.id,
    }));
    const genericLmsIntegrationConfiguration = Object.entries(Object.assign({}, formState.advancedGenericLmsIntegrationConfiguration)).map(([key, value]) => ({
        key,
        stringValue: value.stringValue,
        longValue: value.longValue,
        booleanValue: value.booleanValue,
        lmsIntegrationId: LmsIntegrationDomainService.general.id,
    }));
    return [...lmsIntegration, ...genericLmsIntegrationConfiguration];
};
export const LmsIntegrationTypeSelector = ({ setSelectedLmsIntegration, editDisabled, }) => {
    const { watch } = useFormContext();
    const lmsIntegration = watch("lmsIntegration");
    setSelectedLmsIntegration(lmsIntegration);
    return (_jsx(SearchField, { label: "Integration Type", name: "lmsIntegration", disabled: editDisabled, as: (provided) => (_jsx(LmsIntegrationSearch, Object.assign({ excludeIds: [
                LmsIntegrationDomainService.general.id,
                LmsIntegrationDomainService.blackboardBuildingBlock.id,
            ] }, provided))) }));
};
const LmsConfigurationField = ({ name, lmsConfiguration, }) => {
    switch (lmsConfiguration.fieldTypeId) {
        case LmsConfigurationDomainService.stringFieldTypeId:
            return (_jsx(TextField, { name: name + ".stringValue", label: lmsConfiguration.key }));
        case LmsConfigurationDomainService.longFieldTypeId:
            return (_jsx(NumberField, { name: name + ".longValue", label: lmsConfiguration.key }));
        case LmsConfigurationDomainService.booleanFieldTypeId:
            return (_jsx(CheckboxField, { name: name + ".booleanValue", label: lmsConfiguration.key }));
        default:
            return (_jsx(TextField, { name: name + ".stringValue", label: lmsConfiguration.key }));
    }
};
const LmsIntegrationConfigurationFields = ({ fieldsData, name, }) => {
    return (_jsx(_Fragment, { children: fieldsData === null || fieldsData === void 0 ? void 0 : fieldsData.map((lmsConfiguration, index) => (_jsx(LmsConfigurationField, { name: name + "." + lmsConfiguration.key, lmsConfiguration: lmsConfiguration }, index + name + lmsConfiguration.key))) }));
};
const LmsIntegrationConfigurationFormFields = ({ data, lmsIntegration, }) => {
    const lmsIntegrationConfigurations = data.filter((lmsConfiguration) => lmsConfiguration.lmsIntegration.id !==
        LmsIntegrationDomainService.general.id && !lmsConfiguration.advanced);
    const advancedGenericLmsIntegrationConfiguration = data.filter((lmsConfiguration) => lmsConfiguration.lmsIntegration.id ===
        LmsIntegrationDomainService.general.id);
    const advancedLmsIntegrationConfigurations = data.filter((lmsConfiguration) => lmsConfiguration.lmsIntegration.id !==
        LmsIntegrationDomainService.general.id && lmsConfiguration.advanced);
    return (_jsxs(_Fragment, { children: [_jsx(CustomCard, { title: lmsIntegration.displayName + " Configuration", className: "mb-3", children: _jsx("div", { className: "card-body", children: _jsx(LmsIntegrationConfigurationFields, { fieldsData: lmsIntegrationConfigurations, name: "lmsIntegrationConfiguration" }) }) }), _jsx(CustomCard, { title: "Advanced " + lmsIntegration.displayName + " Configuration", className: "mb-3", children: _jsx("div", { className: "card-body", children: _jsx(LmsIntegrationConfigurationFields, { fieldsData: advancedLmsIntegrationConfigurations, name: "advancedLmsIntegrationConfiguration" }) }) }), _jsx(CustomCard, { title: "Advanced General Configuration", className: "mb-3", children: _jsx("div", { className: "card-body", children: _jsx(LmsIntegrationConfigurationFields, { fieldsData: advancedGenericLmsIntegrationConfiguration, name: "advancedGenericLmsIntegrationConfiguration" }) }) })] }));
};
const LmsIntegrationForm = ({ data, lmsIntegration, }) => {
    return (_jsx(_Fragment, { children: _jsx(LmsIntegrationConfigurationFormFields, { data: data, lmsIntegration: lmsIntegration }) }));
};
export default LmsIntegrationForm;
